import { Component } from "preact";
import { connectWithTranslations } from "../../common/helpers/translationsHelpers";
import actions from "../../calendar-settings/actions";

class ConfirmationPopUp extends Component {
    render({ translate, cancel, save }) {
        return (
            <div class="fxs_detail fxs_cs_detail">
                <h4 class="fxs_headline_from_small_to_medium">
                    {translate("Pop_Up_Title")}
                </h4>
                <p class="fxs_entryPlain_txt_small">
                    {translate("Pop_Up_Summary")}
                </p>
                <div class="fxs_clearfix fxs_marginBase_top" />
                <button
                    type="button"
                    class="fxs_btn fxs_btn_cta fxs_btn_small fxs_fRight "
                    role="button"
                    onClick={() => save()}
                >
                    {translate("Pop_Up_Confirm_Button")}
                </button>
                <button
                    type="button"
                    class="fxs_btn fxs_fRight fxs_btn_small "
                    role="button"
                    onClick={() => cancel()}
                >
                    {translate("Pop_Up_Cancel_Button")}
                </button>
            </div>
        );
    }
}

export default connectWithTranslations(
    "settings, config",
    actions
)(ConfirmationPopUp);
